module.exports = __webpack_public_path__ + "img/03.bd8732fa.png";